import React, { FC } from "react"
import styled from "styled-components"
import Button from "../../components/Button"
import { algorithms } from "../Algorithms/constant"

interface IControlsProps {
    onChangeAlgo: (e: React.ChangeEvent<HTMLSelectElement>) => void
    selectedAlgo: string
    startSort: boolean
    array: number[]
    onSizeChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    disabled: boolean
    onSort: () => void
    onCreateNewData: () => void
}

const ControlsContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    & > * {
        margin: 20px;
        margin-left: 0;
    }
`

const SelectWrapper = styled.select`
    color: #232b32;
`

const Controls: FC<IControlsProps> = ({
    onChangeAlgo,
    selectedAlgo,
    startSort,
    array,
    onSizeChange,
    disabled,
    onSort,
    onCreateNewData,
}: IControlsProps) => {
    return (
        <ControlsContainer>
            <SelectWrapper
                onChange={onChangeAlgo}
                value={selectedAlgo}
                disabled={startSort}
                aria-label="Select Algorithm"
            >
                <option value="">{"Select Algorithm"}</option>
                {algorithms.map((a) => (
                    <option key={a.name} value={a.value}>
                        {a.name}
                    </option>
                ))}
            </SelectWrapper>

            <input
                className="m-2"
                type="range"
                id="vol"
                value={array.length}
                name="vol"
                min="10"
                max="100"
                onChange={onSizeChange}
                onInput={onSizeChange}
                disabled={disabled}
                aria-label="data element size slider"
            />

            <Button onClick={onCreateNewData} disabled={disabled}>
                {"Create New Data"}
            </Button>

            <Button onClick={onSort} disabled={disabled}>
                {"Visualize"}
            </Button>
        </ControlsContainer>
    )
}

export default Controls
